import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import { BrowserRouter } from 'react-router-dom';
// axios.defaults.baseURL = "http://192.168.0.122/api/hoichoi/hoichoiapi.php";
// axios.defaults.baseURL = "https://api.raihanmiraj.com/hoichoichorki/hoichoiapi.php";
// axios.defaults.baseURL = "http://localhost/mlwbd/api/v2/movieandseriesdownload.php" ok;
axios.defaults.baseURL = "https://api.hoichoi.fun/mflixapi.php"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
